import React, { Component } from 'react';
import Post from './Post';

// use apis to retrieve data and store in the following format.

class Feed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      images: [],
      postData: [],
      text:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit sane ista voluptas. Etiam beatissimum? Illa tamen simplicia, vestra versuta. Quare conare, quaeso.',
    };
  }
  componentDidMount() {
    fetch('https://picsum.photos/v2/list')
      .then((results) => results.json())
      .then((data) => {
        this.setState({
          isLoaded: true,
          images: data,
        });
      });
    fetch('https://randomuser.me/api/?results=50')
      .then((results) => results.json())
      .then((data) => {
        let dataArr = data.results.map((dataObj, i) => {
          return {
            author: dataObj.login.username,
            thumbnail: dataObj.picture.thumbnail,
            hoursOld: i + 1,
          };
        });
        this.setState({ postData: dataArr });
      });
  }

  render() {
    const { username } = this.props;
    const { images } = this.state;
    const { postData } = this.state;
    const { text } = this.state;
    return (
      <div className="posts">
        {images.map((image, i) => (
          <div key={i}>
            <Post
              postData={postData[i]}
              username={username}
              image={image.download_url}
              text={text}
            />
          </div>
        ))}
      </div>
    );
  }
}
export default Feed;
